"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tracker = /** @class */ (function () {
    function Tracker(_a) {
        var environment = _a.environment, logger = _a.logger, network = _a.network, sessionManager = _a.sessionManager, storage = _a.storage, userID = _a.userID;
        this.environment = environment;
        this.logger = logger;
        this.network = network;
        this.sessionManager = sessionManager;
        this.storage = storage;
        this.userID = userID;
    }
    Tracker.prototype.addImpression = function (_a) {
        var campaignID = _a.campaignID, isSession = _a.isSession;
        return __awaiter(this, void 0, void 0, function () {
            var campaignHasBeenRendered, impression, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        campaignHasBeenRendered = this.sessionManager.currentSession.renderedCampaigns.find(function (cid) { return cid === campaignID; });
                        if (isSession && campaignHasBeenRendered)
                            return [2 /*return*/];
                        impression = {
                            campaignID: campaignID,
                            date: new Date(),
                            session: isSession
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        this.sessionManager.addCampaignRendering(campaignID);
                        this.saveImpressionToStorage(impression);
                        return [4 /*yield*/, this.sendImpressionToTracking(campaignID)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        this.logger.error('Error saving impression: ', JSON.stringify(impression), 'Details: ', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // To be called as a callback in a signup event or a button 'convert' (redirect)
    Tracker.prototype.addConversion = function (conversionPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var campaignID, type, element, conversion, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignID = conversionPayload.campaignID, type = conversionPayload.type, element = conversionPayload.element;
                        conversion = {
                            campaignID: campaignID,
                            date: new Date(),
                            type: type
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.saveConversionToStorage(conversion);
                        return [4 /*yield*/, this.sendInteractionToTracking(campaignID, type, element, 'conversion')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.logger.error('Error saving conversion: ', JSON.stringify(conversion), 'Details: ', err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Tracker.prototype.saveConversionToStorage = function (conversion) {
        var conversions = this.storage.get('conversions');
        conversions.push(conversion);
        this.storage.set('conversions', conversions);
    };
    Tracker.prototype.saveRejectionToStorage = function (rejection) {
        var rejections = this.storage.get('rejections');
        rejections.push(rejection);
        this.storage.set('rejections', rejections);
    };
    // To be called as a button 'reject' or when the campaign is dismissed otherwise
    Tracker.prototype.addRejection = function (rejectionPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var campaignID, type, element, rejection, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignID = rejectionPayload.campaignID, type = rejectionPayload.type, element = rejectionPayload.element;
                        rejection = {
                            campaignID: campaignID,
                            date: new Date()
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.saveRejectionToStorage(rejection);
                        return [4 /*yield*/, this.sendInteractionToTracking(campaignID, type, element, 'rejection')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        this.logger.error('Error saving rejection: ', JSON.stringify(rejection), 'Details: ', err_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Tracker.prototype.sendGamePlayedEvent = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var campaignID, type, element, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        campaignID = payload.campaignID, type = payload.type, element = payload.element;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendInteractionToTracking(campaignID, type, element, 'gamePlayed')];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        this.logger.error('Error sending navigation event: ', JSON.stringify({
                            campaignID: campaignID,
                            date: new Date(),
                            type: type
                        }), 'Details: ', err_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Tracker.prototype.saveImpressionToStorage = function (impression) {
        var impressions = this.storage.get('impressions');
        impressions.push(impression);
        this.storage.set('impressions', impressions);
    };
    Tracker.prototype.sendImpressionToTracking = function (campaignID) {
        return __awaiter(this, void 0, void 0, function () {
            var cttToken, ecid, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cttToken = this.storage.get('cttToken');
                        ecid = this.storage.get('ecid') || undefined;
                        data = {
                            campaignID: campaignID,
                            cttToken: cttToken === null || cttToken === void 0 ? void 0 : cttToken.value,
                            ecid: ecid,
                            environment: this.environment.snapshot,
                            userID: this.userID
                        };
                        return [4 /*yield*/, this.network.postJson('/api/v2/track/impression', data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Tracker.prototype.sendInteractionToTracking = function (campaignID, type, element, tracking) {
        return __awaiter(this, void 0, void 0, function () {
            var cttToken, ecid, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cttToken = this.storage.get('cttToken');
                        ecid = this.storage.get('ecid') || undefined;
                        data = {
                            action: type,
                            campaignID: campaignID,
                            cttToken: cttToken === null || cttToken === void 0 ? void 0 : cttToken.value,
                            ecid: ecid,
                            element: element,
                            environment: this.environment.snapshot,
                            tracking: tracking,
                            userID: this.userID
                        };
                        return [4 /*yield*/, this.network.postJson("/api/v2/track/".concat(type), data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Tracker;
}());
exports.default = Tracker;
//# sourceMappingURL=data:application/json;base64,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